<mat-toolbar class="header-content">
    <div class="header-title" *ngIf="!renaming">
        <mat-icon>edit</mat-icon>
        {{ tracker.name }}
        <lib-button icon="edit" color="none" textColor="muted" (click)="startRename()" [disabled]="isConnecting"
            tooltip="{{'trackers.rename'|translate}}"></lib-button>
    </div>

    <div class="header-title rename-title" *ngIf="renaming">
        <input matInput type="text" [(ngModel)]="nameDraft" (keydown.enter)="confirmRename()"
            (keydown.escape)="cancelRename()" autofocus>
        <lib-button icon="check" color="none" textColor="primary" (click)="confirmRename()"
            tooltip="{{'form.save'|translate}}"></lib-button>
        <lib-button icon="close" color="none" textColor="muted" (click)="cancelRename()"
            tooltip="{{'form.cancel'|translate}}"></lib-button>
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <div class="info-banner warn-banner" *ngIf="isConnecting">
        <mat-icon>bluetooth_searching</mat-icon>
        <span>{{'trackers.connecting_blocks_edit'|translate}}</span>
    </div>

    <!-- The form below edits this tracker's own settings directly (see save()). The select shows
         the template linked to the tracker (tracker.config) and picking one prefills the fields
         from it (editor.applyTemplate()) - configuring straight from scratch, with nothing picked,
         works exactly the same. -->
    <div [class.connecting-disabled]="isConnecting">
        <div class="config-select-row">
            <mat-form-field appearance="outline" class="header-input">
                <mat-label>{{'resources.select_kyd_template'|translate}}</mat-label>

                <mat-select [value]="editor.appliedTemplateId" (selectionChange)="editor.applyTemplate($event.value)"
                    name="kydTemplate">
                    <mat-option *ngFor="let config of editor.templates" [value]="config.id">{{config.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="template-hint">{{'resources.select_kyd_template_hint'|translate}}</div>

        <app-tracker-config-form [config]="editor.draft" [lockType]="type" [hideName]="true" (save)="save()"
            (saveAsTemplate)="onSaveAsTemplate()" (cancelForm)="cancel()"></app-tracker-config-form>
    </div>

    <mat-expansion-panel *ngIf="tracker.rawData" class="raw-data-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>memory</mat-icon>
                {{'trackers.raw_data_title'|translate}}
            </mat-panel-title>
            <mat-panel-description *ngIf="tracker.rawDataAt">
                {{'trackers.raw_data_read_at'|translate}} {{ tracker.rawDataAt | date:'short' }}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <p class="raw-data-hint">{{'trackers.raw_data_hint'|translate}}</p>

        <table class="raw-data-table">
            <tr *ngFor="let entry of rawDataEntries()">
                <td class="raw-data-key">{{ entry.key }}</td>
                <td class="raw-data-value">{{ entry.value }}</td>
            </tr>
        </table>
    </mat-expansion-panel>
</mat-dialog-content>
